import { useQuery } from "@tanstack/react-query";
import ApiService from "../services/api";
import toast from "react-hot-toast";
import { ClassroomWithRatio, ClockedInEmployee } from "../types";
import { GetAllTeacherProfilesReturn, GetSignedInTeachersWithProfilesReturn } from "../types/api";

// Get refresh interval from environment variable or use default (60 seconds)
const REFRESH_INTERVAL = parseInt(import.meta.env.VITE_REFRESH_INTERVAL || '60000', 10);

export function useStaffData(options?: { autoRefresh?: boolean }) {
    const autoRefresh = options?.autoRefresh ?? true;
    
    return useQuery({
        queryKey: ["staffData"],
        queryFn: async () => {
            toast.loading("Refreshing data...", {
                id: "queryLoading",
                duration: Infinity,
            });

            try {
                const [
                    smartcareCheckedInStaff,
                    wheniworkClockedinStaff,
                    smartcareStaffProfiles
                ] = await Promise.all([
                        ApiService.getSignedInTeachersWithProfiles(),
                        ApiService.getClockedInEmployees(),
                        ApiService.getAllTeacherProfiles()
                ]);

                return {
                        smartcareCheckedInStaff,
                        wheniworkClockedinStaff,
                        smartcareStaffProfiles
                };
            } catch (error) {
                toast.error("Failed to load staff data", {
                    id: "queryError",
                    duration: Infinity,
                });
                throw error;
            } finally {
                toast.dismiss("queryLoading");
            }
        },
        refetchInterval: autoRefresh ? REFRESH_INTERVAL : undefined,
        staleTime: 1*60*1000
    });
}